import axiosClient from "../../../../axiosClient"

export default async () => {
    const result = await axiosClient.get(`/pre-check-requestors`)
    return result.data
}
